import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConceptFamilyListComponent } from './conceptfamily-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { ConceptFamilyService } from './conceptfamily.service';

@Component({
    selector: 'convfact-conceptfamilydelete',
    templateUrl: './conceptfamily-dialog-delete.component.html',
    styleUrls: ['./conceptfamily.component.css'],
    standalone: false
})

export class ConceptFamilyDialogDeleteComponent {
    uid: string = this.data.uid;
    type: string = this.data.type;
    error_msg: string;
    error = false;

    constructor(
        public dialogRef: MatDialogRef<ConceptFamilyListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public conceptFamilyService: ConceptFamilyService
    ) { }


    delete() {
        this.conceptFamilyService.deleteData(this.uid);
        this.error = true;
    }

    closeDialog() {
        this.dialogRef.close();
    }

}
